import {
  CircularProgress,
  IconButton,
  Paper,
  TextField,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import RemoveIcon from '@material-ui/icons/Close'
import DoneIcon from '@material-ui/icons/Done'
import LinkIcon from '@material-ui/icons/Link'
import RetryIcon from '@material-ui/icons/Refresh'
import { memo, useEffect, useState } from 'react'

import { ImageProps } from '../UploadBox/ImageBox'
import ImageBoxSkeleton from '../UploadBox/ImageBox.skeleton'
import useStyles from '../UploadBox/styles/index.styles'

export enum FileStatus {
  UPLOADING,
  ERROR,
  COMPLETED,
  DELETING,
  TYPING_NAME
}

interface ImageBoxProps {
  item: ImageProps
  onChange: (newImage: ImageProps) => void
  imageType: string
  onUpload: () => void
  onDelete: () => void
}
const ImageBox: React.FC<ImageBoxProps> = ({
  item,
  onChange,
  onDelete,
  onUpload
}) => {
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'))

  const [pageIsReady, setPageIsReady] = useState<boolean>(
    item.status === FileStatus.TYPING_NAME
  )
  const [imageLoaded, setimageLoaded] = useState(false)
  const classes = useStyles()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [percent, setpercent] = useState(0)
  const [error, seterror] = useState(false)
  const handleCompletedName = async () => {
    setPageIsReady(true)
  }
  const handleUploadImage = async () => {
    setPageIsReady(true)
    onChange({
      ...item,
      status: FileStatus.UPLOADING
    })
    seterror(false)
    onUpload()
  }

  useEffect(() => {
    if (item.status === FileStatus.UPLOADING) {
      handleUploadImage()
    } else if (item.status === FileStatus.COMPLETED) {
      handleCompletedName()
    }
  }, [])

  const handleDeleteFromServer = () => {
    onChange({
      ...item,
      status: FileStatus.DELETING
    })

    onDelete()
  }

  const ShowOptions = () => {
    switch (item.status) {
      case FileStatus.COMPLETED:
        return (
          <>
            <IconButton
              className={classes.linkIcon}
              size={isSmall ? 'small' : 'medium'}>
              <a href={item.fileURL} target="'_blank'">
                <LinkIcon />
              </a>
            </IconButton>
            <IconButton
              onClick={handleDeleteFromServer}
              size={isSmall ? 'small' : 'medium'}>
              <RemoveIcon />
            </IconButton>
          </>
        )
      case FileStatus.UPLOADING:
        return <CircularProgress size={30} />
      case FileStatus.ERROR:
        return (
          <>
            <IconButton onClick={handleUploadImage}>
              <RetryIcon />
            </IconButton>
            <IconButton onClick={onDelete}>
              <RemoveIcon />
            </IconButton>
          </>
        )
      case FileStatus.DELETING:
        return <CircularProgress size={30} />
      case FileStatus.TYPING_NAME:
        return (
          <>
            <IconButton onClick={handleUploadImage}>
              <DoneIcon />
            </IconButton>
            <IconButton onClick={onDelete}>
              <RemoveIcon />
            </IconButton>
          </>
        )
      default:
        return null
    }
  }
  if (pageIsReady)
    return (
      <Paper
        className={[classes.item, error ? classes.itemError : ''].join(' ')}
        elevation={4}>
        {item.status === FileStatus.UPLOADING && (
          <div
            className={classes.progressbar}
            style={{
              width: `${percent}%`
            }}
          />
        )}
        <div className={classes.parentDiv}>
          <div className={classes.thumbnail}>
            <img
              src={item.fileURL}
              className={[
                classes.img,
                imageLoaded ? classes.imgVisible : ''
              ].join(' ')}
              alt={item.fileName}
              onLoad={() => setimageLoaded(true)}
            />
          </div>
          <div className={classes.details}>
            {item.status === FileStatus.TYPING_NAME ? (
              <TextField
                fullWidth
                value={item.fileName}
                onChange={(event) =>
                  onChange({
                    ...item,
                    fileName: event.currentTarget.value
                  })
                }
              />
            ) : (
              <Typography variant="body1">
                {item.fileName.length < 4 || !isSmall
                  ? item.fileName
                  : `${item.fileName.substr(0, 3)}...`}
              </Typography>
            )}
            <Typography variant="caption">
              {item.fileSize
                ? `${parseInt((item.fileSize / 1000).toString(), 10)} kb`
                : ''}
            </Typography>
          </div>
          {ShowOptions()}
        </div>
      </Paper>
    )
  return <ImageBoxSkeleton />
}

export default memo(ImageBox)
